import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
const tabsOptions = [
    { label: 'Overview', value: 'overview' },
    { label: 'Shop', value: 'shop' },
    { label: 'Memberships', value: 'memberships' },
];
export const useAnalyticsTabs = () => {
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const [searchParams, setSearchParams] = useSearchParams();
    const { currentShop } = useCurrentShop({ staleTime: Infinity });
    const membershipsEnabled = !!currentShop?.settings.memberships?.enabled && dashboardFeatureFlags.memberships.enabled;
    const isAnalyticsTabsEnabled = dashboardFeatureFlags.analyticsTabs.enabled && membershipsEnabled;
    const tabParam = searchParams.get('tab') || '';
    const isValidTab = tabsOptions.some((tab) => tab.value === tabParam);
    const activeTab = isValidTab ? tabParam : 'overview';
    useEffect(() => {
        if (!isAnalyticsTabsEnabled) {
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete('tab');
            setSearchParams(newSearchParams);
        }
        else if (!isValidTab) {
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.set('tab', 'overview');
            setSearchParams(newSearchParams);
        }
    }, [isAnalyticsTabsEnabled, isValidTab, searchParams, setSearchParams]);
    const handleTabChange = (value) => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('tab', value);
        setSearchParams(newSearchParams);
    };
    return {
        areTabsEnabled: isAnalyticsTabsEnabled,
        tabsOptions,
        activeTab,
        onTabChange: handleTabChange,
    };
};
